import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";

defineComponent({
  tag: "oc-interactive-overlay-v2",
  extendOptions: { useShadow: false, useOcAutoAriaLabel: true },
  styles: () => import("./InteractiveOverlayV2.global.scss?inline"),
  props: {},
});
